
import { useState } from "react";
import DashboardHeader from "./DashboardHeader";
import DashboardSidebar from "./DashboardSidebar";
import SubscriptionStatusCard from "./SubscriptionStatusCard";
import PreferencesTab from "./tabs/PreferencesTab";
import IntegrationsTab from "./tabs/IntegrationsTab";
import BillingTab from "./tabs/BillingTab";

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("preferences");

  const renderContent = () => {
    switch (activeTab) {
      case "integrations":
        return <IntegrationsTab />;
      case "billing":
        return <BillingTab />;
      default: // preferences
        return <PreferencesTab />;
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <DashboardSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />

      {/* Main Content */}
      <div className="lg:ml-64">
        <DashboardHeader onSidebarToggle={() => setSidebarOpen(true)} />

        {/* Dashboard Content - Centered with max width */}
        <main className="p-4 lg:p-8 flex justify-center">
          <div className="w-full max-w-4xl space-y-6 lg:space-y-8">
            <SubscriptionStatusCard />

            {/* Settings Tabs */}
            <div className="mb-6">
              <div className="flex space-x-4 lg:space-x-8 border-b border-gray-200 overflow-x-auto">
                <button 
                  className={`pb-2 border-b-2 font-medium whitespace-nowrap ${
                    activeTab === "preferences" 
                      ? "border-purple-600 text-purple-600" 
                      : "border-transparent text-gray-600 hover:text-gray-900"
                  }`}
                  onClick={() => setActiveTab("preferences")}
                >
                  Preferences
                </button>
                <button 
                  className={`pb-2 border-b-2 font-medium whitespace-nowrap ${
                    activeTab === "integrations" 
                      ? "border-purple-600 text-purple-600" 
                      : "border-transparent text-gray-600 hover:text-gray-900"
                  }`}
                  onClick={() => setActiveTab("integrations")}
                >
                  Integrations
                </button>
                <button 
                  className={`pb-2 border-b-2 font-medium whitespace-nowrap ${
                    activeTab === "billing" 
                      ? "border-purple-600 text-purple-600" 
                      : "border-transparent text-gray-600 hover:text-gray-900"
                  }`}
                  onClick={() => setActiveTab("billing")}
                >
                  Billing
                </button>
              </div>
            </div>

            {/* Tab Content */}
            {renderContent()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
